import { useDispatch } from 'react-redux'
import { UserDocumentTemplate, SingleTemplateSettings, Resume } from '@rio/types'

import { i18n } from 'builder/utils/i18n'
import { TooltipV2 } from 'builder/components/Tooltip'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { ColorChangeHandler, actions } from 'builder/modules/resumeEditor'
import { Colors as ColorSelect } from 'builder/components/DocumentCustomizationModal/Colors'
import { useUpdateTemplateSettings } from 'builder/components/DocumentCustomizationModal/components/ResumeSidebar/hooks/useUpdateTemplateSettings'
import * as Styled from './styles'

type Props = {
  resume?: Resume
  currentTemplate?: UserDocumentTemplate
  resumeSpecificTemplateSettings?: SingleTemplateSettings
}

export const ColorList = ({ resume, currentTemplate, resumeSpecificTemplateSettings }: Props) => {
  const { supportsCustomColor, supportsNewCustomization, settings } = currentTemplate || {}
  const dispatch = useDispatch()
  const { isAboveTablet } = useMediaQueries()
  const { updateTemplateSettings } = useUpdateTemplateSettings(resume)

  const getSelectedColor = () => {
    if (supportsCustomColor && supportsNewCustomization) {
      return resumeSpecificTemplateSettings?.color || settings?.color?.default || resume?.color
    }
    return resume?.color || settings?.color?.default
  }

  const handleColorSelect: ColorChangeHandler = color => {
    if (supportsCustomColor && supportsNewCustomization) {
      updateTemplateSettings({ settingsName: 'color', value: color || '' })
    } else {
      dispatch(actions.updateSimpleField({ name: 'color', value: color, debounce: false }))
    }
  }

  return (
    <TooltipV2
      value={i18n.t('builder.resume_editor.no_color')}
      width={165}
      position="bottom"
      multiline={true}
      isActive={!settings?.color?.values?.length}
    >
      <Styled.Container>
        <ColorSelect
          isNewBuilder
          size={isAboveTablet ? 32 : 44}
          options={settings?.color?.values || []}
          selected={getSelectedColor()}
          onSelect={handleColorSelect}
          supportsCustomColor={supportsCustomColor}
        />
      </Styled.Container>
    </TooltipV2>
  )
}
